import viewSonicImg from "../../assets/image/panels/viewsonic.png";
import benqImg from "../../assets/image/panels/benq.png";
import samsungImg from "../../assets/image/panels/samsung.png";
import prometheanImg from "../../assets/image/panels/promethean.png";
import maxhubImg from "../../assets/image/panels/maxhub.png";
import lgImg from "../../assets/image/panels/lg.png";
import newlineImg from "../../assets/image/panels/newline.png";
import surfaceHubImg from "../../assets/image/panels/surfacehub.png";
import Img from "../../assets/image/panels/gyanna.png";
import Img1 from "../../assets/image/panels/gyanaaops.png";

const interactivePanels = [
  {
    name: "Gyanaa  interactive flat",
    brand: "Gyanaa ",
    size: '55" - 98"',
    spec: "4K UHD | Android | Multi-touch",
    price: 145000,
    oldPrice: 168000,
    badge: "EDUCATION FAVORITE",
    image: Img
  },
   {
    name: "Gyanaa OPS (Open Pluggable System)",
    brand: "Gyanaa ",
    size: '8GB" - 32GB Storage',
    spec: "4K UHD | Android | Multi-touch",
    price: 145000,
    oldPrice: 168000,
    badge: "OPS FAVORITE",
    image: Img1
  },
  {
    name: "ViewSonic IFP Series",
    brand: "ViewSonic",
    size: '55" - 98"',
    spec: "4K UHD | Android | Multi-touch",
    price: 145000,
    oldPrice: 168000,
    badge: "EDUCATION ",
    image: viewSonicImg
  },
  {
    name: "BenQ RP Series",
    brand: "BenQ",
    size: '65" - 86"',
    spec: "Eye-care Technology | Classroom Optimized",
    price: 158000,
    oldPrice: 179000,
    badge: "CLASSROOM PRO",
    image: benqImg
  },
  {
    name: "Samsung Flip Pro",
    brand: "Samsung",
    size: '55" - 86"',
    spec: "Smooth Writing | Wireless Casting",
    price: 172000,
    oldPrice: 195000,
    badge: "PREMIUM DESIGN",
    image: samsungImg
  },
  {
    name: "Promethean ActivPanel",
    brand: "Promethean",
    size: '65" - 86"',
    spec: "Education Collaboration Suite",
    price: 565000,
    oldPrice: 509000,
    badge: "SMART LEARNING",
    image: prometheanImg
  },
  {
    name: "MAXHUB Interactive Display",
    brand: "MAXHUB",
    size: '65" - 98"',
    spec: "Ultra Fast Touch | Conference Ready",
    price: 182000,
    oldPrice: 210000,
    badge: "BUSINESS PRO",
    image: maxhubImg
  },
  {
    name: "LG CreateBoard",
    brand: "LG",
    size: '65" - 86"',
    spec: "Premium Display | Smart Annotation",
    price: 176000,
    oldPrice: 199000,
    badge: "HIGH PERFORMANCE",
    image: lgImg
  },
  {
    name: "Newline Interactive Panel",
    brand: "Newline",
    size: '65" - 98"',
    spec: "Third Party App Integration",
    price: 162000,
    oldPrice: 185000,
    badge: "FLEXIBLE",
    image: newlineImg
  },
  {
    name: "Microsoft Surface Hub 3",
    brand: "Microsoft",
    size: '50" - 85"',
    spec: "Teams Collaboration | Windows OS",
    price: 420000,
    oldPrice: 465000,
    badge: "COLLABORATION",
    image: surfaceHubImg
  }
];

export default interactivePanels;
